import { BaseBean } from "./BaseBean";


export class LenguaBean extends BaseBean{

  public id:number;
  public nombre:string;

}
